/*
 * File: AlertsBarAlerts.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays alert bar at the top of the page
 */
import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import AlertIcon from "@material-ui/icons/Warning";
import AlertStore from "services/patients/alerts/Store";
import { useStore } from "utils/useStore";
import { observer } from "mobx-react";

const styles = {
  icon: {
    width: 28,
    position: "absolute",
    left: 14,
    top: 2,
    color: "#ff9232"
  }
};

const AlertBarAlerts = ({ classes }) => {
  let { alertString, toggleDialog } = useStore(AlertStore);
  if (!alertString) return null;
  return (
    <div className="animated slideInDown">
      <Typography onClick={toggleDialog}>
        <AlertIcon className={classes.icon} />
        {alertString}
      </Typography>
    </div>
  );
};

AlertBarAlerts.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(observer(AlertBarAlerts));
